import { HoneycombTilemapChart } from '@/common/dashboard/charts/HoneycombTilemapChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { Box, Paper, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { US_STATE_SVG_PATHS } from './US_STATE_SVG_PATHS';

const US_STATE_TILEMAP_DATA = [
  { 'hc-a2': 'AL', name: 'Alabama', region: 'South', x: 6, y: 7 },
  { 'hc-a2': 'AK', name: 'Alaska', region: 'West', x: 0, y: 0 },
  { 'hc-a2': 'AZ', name: 'Arizona', region: 'West', x: 5, y: 3 },
  { 'hc-a2': 'AR', name: 'Arkansas', region: 'South', x: 5, y: 6 },
  { 'hc-a2': 'CA', name: 'California', region: 'West', x: 5, y: 2 },
  { 'hc-a2': 'CO', name: 'Colorado', region: 'West', x: 4, y: 3 },
  { 'hc-a2': 'CT', name: 'Connecticut', region: 'Northeast', x: 3, y: 11 },
  { 'hc-a2': 'DE', name: 'Delaware', region: 'South', x: 4, y: 9 },
  { 'hc-a2': 'DC', name: 'District of Columbia', region: 'South', x: 4, y: 10 },
  { 'hc-a2': 'FL', name: 'Florida', region: 'South', x: 8, y: 8 },
  { 'hc-a2': 'GA', name: 'Georgia', region: 'South', x: 7, y: 8 },
  { 'hc-a2': 'HI', name: 'Hawaii', region: 'West', x: 8, y: 0 },
  { 'hc-a2': 'ID', name: 'Idaho', region: 'West', x: 3, y: 2 },
  { 'hc-a2': 'IL', name: 'Illinois', region: 'Midwest', x: 3, y: 6 },
  { 'hc-a2': 'IN', name: 'Indiana', region: 'Midwest', x: 3, y: 7 },
  { 'hc-a2': 'IA', name: 'Iowa', region: 'Midwest', x: 3, y: 5 },
  { 'hc-a2': 'KS', name: 'Kansas', region: 'Midwest', x: 5, y: 5 },
  { 'hc-a2': 'KY', name: 'Kentucky', region: 'South', x: 4, y: 6 },
  { 'hc-a2': 'LA', name: 'Louisiana', region: 'South', x: 6, y: 5 },
  { 'hc-a2': 'ME', name: 'Maine', region: 'Northeast', x: 0, y: 11 },
  { 'hc-a2': 'MD', name: 'Maryland', region: 'South', x: 4, y: 8 },
  { 'hc-a2': 'MA', name: 'Massachusetts', region: 'Northeast', x: 2, y: 10 },
  { 'hc-a2': 'MI', name: 'Michigan', region: 'Midwest', x: 2, y: 7 },
  { 'hc-a2': 'MN', name: 'Minnesota', region: 'Midwest', x: 2, y: 4 },
  { 'hc-a2': 'MS', name: 'Mississippi', region: 'South', x: 6, y: 6 },
  { 'hc-a2': 'MO', name: 'Missouri', region: 'Midwest', x: 4, y: 5 },
  { 'hc-a2': 'MT', name: 'Montana', region: 'West', x: 2, y: 2 },
  { 'hc-a2': 'NE', name: 'Nebraska', region: 'Midwest', x: 4, y: 4 },
  { 'hc-a2': 'NV', name: 'Nevada', region: 'West', x: 4, y: 2 },
  { 'hc-a2': 'NH', name: 'New Hampshire', region: 'Northeast', x: 1, y: 11 },
  { 'hc-a2': 'NJ', name: 'New Jersey', region: 'Northeast', x: 3, y: 10 },
  { 'hc-a2': 'NM', name: 'New Mexico', region: 'West', x: 6, y: 3 },
  { 'hc-a2': 'NY', name: 'New York', region: 'Northeast', x: 2, y: 9 },
  { 'hc-a2': 'NC', name: 'North Carolina', region: 'South', x: 5, y: 9 },
  { 'hc-a2': 'ND', name: 'North Dakota', region: 'Midwest', x: 2, y: 3 },
  { 'hc-a2': 'OH', name: 'Ohio', region: 'Midwest', x: 3, y: 8 },
  { 'hc-a2': 'OK', name: 'Oklahoma', region: 'South', x: 6, y: 4 },
  { 'hc-a2': 'OR', name: 'Oregon', region: 'West', x: 4, y: 1 },
  { 'hc-a2': 'PA', name: 'Pennsylvania', region: 'Northeast', x: 3, y: 9 },
  { 'hc-a2': 'PR', name: 'Puerto Rico', region: 'Territory', x: 8, y: 11 },
  { 'hc-a2': 'RI', name: 'Rhode Island', region: 'Northeast', x: 2, y: 11 },
  { 'hc-a2': 'SC', name: 'South Carolina', region: 'South', x: 6, y: 8 },
  { 'hc-a2': 'SD', name: 'South Dakota', region: 'Midwest', x: 3, y: 4 },
  { 'hc-a2': 'VI', name: 'U.S. Virgin Islands', region: 'Territory', x: 8, y: 12 },
  { 'hc-a2': 'TN', name: 'Tennessee', region: 'South', x: 5, y: 7 },
  { 'hc-a2': 'TX', name: 'Texas', region: 'South', x: 7, y: 4 },
  { 'hc-a2': 'UT', name: 'Utah', region: 'West', x: 5, y: 4 },
  { 'hc-a2': 'GU', name: 'Guam', region: 'Territory', x: 8, y: 13 },
  { 'hc-a2': 'VT', name: 'Vermont', region: 'Northeast', x: 1, y: 10 },
  { 'hc-a2': 'VA', name: 'Virginia', region: 'South', x: 5, y: 8 },
  { 'hc-a2': 'WA', name: 'Washington', region: 'West', x: 2, y: 1 },
  { 'hc-a2': 'AS', name: 'American Samoa', region: 'Territory', x: 8, y: 14 },
  { 'hc-a2': 'WV', name: 'West Virginia', region: 'South', x: 4, y: 7 },
  { 'hc-a2': 'WI', name: 'Wisconsin', region: 'Midwest', x: 2, y: 5 },
  { 'hc-a2': 'WY', name: 'Wyoming', region: 'West', x: 3, y: 3 },
];

// const ZERO_PERCENT_STATES = new Set(['AK', 'WY', 'VT', 'ND', 'DC']);
// const HIGH_DISPUTE_STATES = new Set(['CA', 'TX', 'FL', 'NY', 'IL', 'PA']);
// const HIGH_DUE_AMOUNT_STATES = new Set(['CA', 'TX', 'AZ', 'CO', 'GA', 'MI', 'MO', 'NC', 'NJ', 'OH']);
const DISPUTE_ALERT_THRESHOLD = 700_000;
// const DUE_AMOUNT_THRESHOLD = 500_000;

const getProgressBandColors = (percent) => {
  if (percent >= 100) {
    return {
      fillStart: '#0d47a1' /* green: '#1b5e20' */,
      fillEnd: '#1565c0' /* green: '#2e7d32' */,
      emptyStart: '#e3f2fd' /* green: '#e8f5e9' */,
      emptyEnd: '#e3f2fd' /* green: '#e8f5e9' */,
    };
  }

  if (percent >= 75) {
    return {
      fillStart: '#1565c0' /* green: '#2e7d32' */,
      fillEnd: '#1976d2' /* green: '#388e3c' */,
      emptyStart: '#e3f2fd' /* green: '#e8f5e9' */,
      emptyEnd: '#e8f4fd' /* green: '#edf7ed' */,
    };
  }

  if (percent >= 50) {
    return {
      fillStart: '#1e88e5' /* green: '#43a047' */,
      fillEnd: '#42a5f5' /* green: '#66bb6a' */,
      emptyStart: '#e8f4fd' /* green: '#edf7ed' */,
      emptyEnd: '#eef7fe' /* green: '#f3faf3' */,
    };
  }

  if (percent >= 25) {
    return {
      fillStart: '#64b5f6' /* green: '#81c784' */,
      fillEnd: '#90caf9' /* green: '#a5d6a7' */,
      emptyStart: '#eef7fe' /* green: '#f2faf2' */,
      emptyEnd: '#f4f9fe' /* green: '#f7fcf7' */,
    };
  }

  return {
    fillStart: '#90caf9' /* green: '#dce9dc' */,
    fillEnd: '#bbdefb' /* green: '#e6efe6' */,
    emptyStart: '#f0f7ff' /* green: '#f6f9f6' */,
    emptyEnd: '#f7fbff' /* green: '#fbfdfb' */,
  };
};

export const McdStateProgressChart = ({ formValues, endDateToStartDate, isCld = false }) => {
  const { invPeriodId, stateIds, ctrtIds, checkRunDates } = formValues;

  const rsrc = useRsrc();
  const { navigateTo } = useNavState();
  const [data, setData] = useState();

  useEffect(() => {
    const endDate = Math.max(...checkRunDates);
    const minEndDate = Math.min(...checkRunDates);
    const startDate = endDateToStartDate[minEndDate];
    const reqParam = {
      periodId: invPeriodId,
      stateIds,
      ctrtIds,
      startDate,
      endDate,
      isCld,
    };

    rsrc.data('sc', 'MCD_STATE_PROGRESS_CHART_DATA_PLUGIN', reqParam).then((data) => {
      setData(data);
    });
  }, [invPeriodId, stateIds, ctrtIds, checkRunDates, endDateToStartDate, isCld]);

  const [selectedTile, setSelectedTile] = useState(null);
  const disputeBellSvg = icon(fas.faBell, {
    styles: {
      color: '#d32f2f',
      width: '0.7em',
      height: '0.7em',
      display: 'block',
    },
  }).html.join('');
  const cldBellSvg = icon(fas.faBell, {
    styles: {
      color: '#f9a825',
      width: '0.7em',
      height: '0.7em',
      display: 'block',
    },
  }).html.join('');

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(Number(amount) || 0);
  };

  const buildProgressFillColor = (percent) => {
    const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
    const split = safePercent / 100;
    const { fillStart, fillEnd, emptyStart, emptyEnd } = getProgressBandColors(safePercent);

    if (split <= 0) {
      return {
        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
        stops: [
          [0, emptyStart],
          [1, emptyEnd],
        ],
      };
    }

    if (split >= 1) {
      return {
        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
        stops: [
          [0, fillStart],
          [1, fillEnd],
        ],
      };
    }

    return {
      // The tilemap is rendered inverted; flip x-axis direction for bottom-to-top appearance.
      linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
      stops: [
        [0, fillStart],
        [split, fillEnd],
        [split, emptyStart],
        [1, emptyEnd],
      ],
    };
  };

  const mapData = useMemo(() => {
    // Build a lookup from stateCode -> backend row
    const backendByState = {};
    if (data) {
      for (const row of data) {
        backendByState[row.stateCode] = row;
      }
    }

    const selectedStateTokens = new Set(
      (stateIds || [])
        .flatMap((state) => [state?.code, state?.name])
        .filter(Boolean)
        .map((value) => String(value).trim().toUpperCase()),
    );

    /*
    // --- FAKE DATA (preserved for reference) ---
    const ctrtCount = selectedCtrts.length;
    const periodSeed = Number(selectedPeriod?.id || 0);
    const dueDateSeed = selectedDueDate?.endDate || selectedDueDate?.displayValue || '';

    const hashString = (value) => {
      let hash = 0;
      const str = String(value || '');
      for (let i = 0; i < str.length; i += 1) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    };

    const formatDate = (date) => {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    // .map((state) => {
    //   const seed = `${state['hc-a2']}-${periodSeed}-${dueDateSeed}-${ctrtCount}-${isCld}`;
    //   const hash = hashString(seed);
    //   const bucket = hash % 5;
    //   let percent = 0;
    //   if (ZERO_PERCENT_STATES.has(state['hc-a2'])) { percent = 0; }
    //   else if (bucket === 0) { percent = 1 + (hash % 20); }
    //   else if (bucket === 1) { percent = 20 + (hash % 21); }
    //   else if (bucket === 2) { percent = 40 + (hash % 21); }
    //   else if (bucket === 3) { percent = 60 + (hash % 31); }
    //   else { percent = 90 + (hash % 11); }
    //
    //   const pymtCount = 2 + (hash % 5);
    //   const pymtIds = Array.from({ length: pymtCount }, (_, i) => hash + i + 1000);
    //   const abbrev = String(state['hc-a2']);
    //   const mediTotal = 18 + (hash % 70);
    //   const mmcoTotal = 14 + ((hash >> 2) % 55);
    //   const adapTotal = 10 + ((hash >> 4) % 45);
    //   const totalInvoices = mediTotal + mmcoTotal + adapTotal;
    //   const totalCompleted = Math.round((percent / 100) * totalInvoices);
    //   const mediCompleted = Math.min(mediTotal, Math.max(0, Math.round((percent / 100) * mediTotal)));
    //   const mmcoCompleted = Math.min(mmcoTotal, Math.max(0, Math.round((percent / 100) * mmcoTotal)));
    //   const adapCompleted = Math.min(adapTotal, Math.max(0, totalCompleted - mediCompleted - mmcoCompleted));
    //   const programInvoices = {
    //     [`${abbrev} MEDI`]: { completed: mediCompleted, total: mediTotal },
    //     [`${abbrev} MMCO`]: { completed: mmcoCompleted, total: mmcoTotal },
    //     [`${abbrev} ADAP`]: { completed: adapCompleted, total: adapTotal },
    //   };
    //   const firstExpectedInvoiceOn = (() => {
    //     if (percent !== 0) return null;
    //     const baseDate = new Date(Date.UTC(2026, 5, 11));
    //     const invoiceDate = new Date(baseDate);
    //     invoiceDate.setUTCDate(baseDate.getUTCDate() + (hash % 31));
    //     return formatDate(invoiceDate);
    //   })();
    //   const disputeAmount = HIGH_DISPUTE_STATES.has(abbrev) ? 1_100_000 + (hash % 700_000) : 120_000 + (hash % 780_000);
    //   const dueAmount = HIGH_DUE_AMOUNT_STATES.has(abbrev) ? 600_000 + ((hash >> 3) % 900_000) : 50_000 + ((hash >> 3) % 450_000);
    //   return { ...state, value: percent, color: buildProgressFillColor(percent), pymtIds,
    //     programInvoices, firstExpectedInvoiceOn,
    //     disputeAmount, hasDisputeAlert: disputeAmount > DISPUTE_ALERT_THRESHOLD,
    //     dueAmount, hasDueAlert: percent > 0 && dueAmount > DUE_AMOUNT_THRESHOLD };
    // })
    */

    return US_STATE_TILEMAP_DATA.filter((state) => {
      if (!selectedStateTokens.size) return true;
      const stateCode = String(state['hc-a2']).toUpperCase();
      const stateName = String(state.name || '')
        .trim()
        .toUpperCase();
      return selectedStateTokens.has(stateCode) || selectedStateTokens.has(stateName);
    }).map((state) => {
      const abbrev = state['hc-a2'];
      const backendRow = backendByState[abbrev];

      if (!backendRow) {
        return {
          ...state,
          value: 0,
          color: buildProgressFillColor(0),
          programInvoices: {},
          firstExpectedInvoiceOn: null,
          disputeAmount: 0,
          hasDisputeAlert: false,
          dueAmount: 0,
          hasDueAlert: false,
        };
      }

      const percent = backendRow.completionPercent;

      // Backend programInvoices: { [stateCode + " " + progCode]: { total, previous } }
      // 'total'    = current quarter total invoice count
      // 'previous' = prior quarter settled count (expected baseline)
      // Map to UI shape { completed, total } so the card reads "current / expected"
      const programInvoices = {};
      for (const [key, val] of Object.entries(backendRow.programInvoices || {})) {
        programInvoices[key] = { completed: val.total, total: val.previous };
      }

      const disputeAmount = Number(backendRow.disputeAmount) || 0;
      const dueAmount = Number(backendRow.dueAmount) || 0;
      const hasDisputeAlert = disputeAmount > DISPUTE_ALERT_THRESHOLD;
      const hasDueAlert = percent > 0 && dueAmount !== 0; //> DUE_AMOUNT_THRESHOLD;

      return {
        ...state,
        value: percent,
        color: buildProgressFillColor(percent),
        programInvoices,
        firstExpectedInvoiceOn: backendRow.firstExpectedInvoiceOn,
        disputeAmount,
        hasDisputeAlert,
        dueAmount,
        hasDueAlert,
      };
    });
  }, [data, stateIds]);

  const overallPercent = useMemo(() => {
    if (!data || data.length === 0) return null;
    const totalInvoices = data.reduce((sum, row) => sum + (row.totalCount ?? 0), 0);
    const prevInvoices = data.reduce((sum, row) => sum + (row.prevCount ?? 0), 0);
    if (prevInvoices === 0) return null;
    return Math.round((totalInvoices / prevInvoices) * 100);
  }, [data]);

  const navigateToInvList = () => {
    if (!selectedTile) return;
    let expr = ExprUtils.whereParams('invPeriodId', invPeriodId);
    const stateCode = selectedTile['hc-a2'];
    if (stateCode) {
      expr = ExprUtils.and(expr, ExprUtils.whereParams('stateCode', stateCode));
    }
    navigateTo('sc/mcd-inv', { mode: Mode.LIST, expr });
  };

  const handleTileClick = (dataPoint) => {
    setSelectedTile(dataPoint);
  };

  if (data === undefined) return null;
  if (!mapData.length) return null;

  return (
    <Box sx={{ display: 'flex', gap: 2, minHeight: 680, height: '100%', alignItems: 'stretch' }}>
      <Box sx={{ flex: 1, minWidth: 0, minHeight: 680, position: 'relative' }}>
        <HoneycombTilemapChart
          data={mapData}
          // title="Quarterly Invoice Progress by State"
          // subtitle="Mock percentages grouped by range"
          seriesName="State Progress"
          dataLabels
          dataLabelStyle={{ fontSize: '20px', fontWeight: 900 }}
          inverted
          chartHeight="100%"
          chartMargins={{ top: 48, right: 96, bottom: 48, left: 96 }}
          accessibility={{
            description:
              'A tile map represents state-level progress percentages using hexagonal tiles in a U.S. layout.',
            point: {
              valueDescriptionFormat: '{index}. {xDescription}, {point.value}.',
            },
          }}
          colorAxis={{
            min: 0,
            max: 100,
            minColor: '#ffffff',
            maxColor: '#1565c0' /* green: '#2e7d32' */,
          }}
          xAxis={{ reversed: true }}
          yAxis={{ reversed: false }}
          tooltipFormatter={function () {
            return false;
          }}
          dataLabelFormatter={(point) => {
            const stateLabel = Number(point.value) >= 100 ? `${point['hc-a2']} ✓` : point['hc-a2'];
            const hasRedBell = Boolean(point.hasDueAlert);
            const hasYellowBell = Boolean(point.hasDisputeAlert);
            const redBell =
              hasRedBell ?
                `<span style="position:absolute;left:-0.45em;top:-0.35em;line-height:1;display:inline-flex;align-items:center;justify-content:center;">${disputeBellSvg}</span>`
              : '';
            const yellowBell =
              hasYellowBell ?
                `<span style="position:absolute;left:${hasRedBell ? '0.35em' : '-0.45em'};top:-0.35em;line-height:1;display:inline-flex;align-items:center;justify-content:center;">${cldBellSvg}</span>`
              : '';
            const bells =
              point.hasDueAlert ? `${redBell}${yellowBell}`
              : hasYellowBell ? yellowBell
              : '';
            return `<div style="position:relative;width:64px;height:48px;line-height:1;pointer-events:none;">${bells}<span style="position:absolute;left:50%;top:52%;transform:translate(-50%,-50%);color:#333333;">${stateLabel}</span></div>`;
          }}
          dataLabelOptions={{ useHTML: true, crop: false, overflow: 'allow' }}
          tilemapOptions={{ tileShape: 'hexagon', pointPadding: 2 }}
          onClick={handleTileClick}
        />
      </Box>

      <Box
        sx={{
          minWidth: 360,
          maxWidth: 440,
          alignSelf: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        {overallPercent !== null &&
          (() => {
            const hexColor = buildProgressFillColor(overallPercent);
            const textColor = overallPercent >= 75 ? '#fff' : '#1a1a1a';
            return (
              <svg viewBox="0 0 100 100" width="200" height="200" overflow="visible" style={{ pointerEvents: 'none' }}>
                <defs>
                  <linearGradient id="overall-hex-grad" x1="0" y1="1" x2="0" y2="0">
                    {hexColor.stops.map(([offset, color], i) => (
                      <stop key={i} offset={offset} stopColor={color} />
                    ))}
                  </linearGradient>
                </defs>
                <polygon
                  points="95,50 72.5,11 27.5,11 5,50 27.5,89 72.5,89"
                  fill="url(#overall-hex-grad)"
                  stroke="#b0b0b0"
                  strokeWidth="1.5"
                />
                <text
                  x="50"
                  y="44"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="24"
                  fontWeight="900"
                  fontFamily="inherit"
                  fill={textColor}
                >
                  {overallPercent}%
                </text>
                <text
                  x="50"
                  y="63"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="16"
                  fontWeight="700"
                  fontFamily="inherit"
                  fill={textColor}
                >
                  Overall
                </text>
              </svg>
            );
          })()}
        <Paper
          elevation={0}
          onClick={selectedTile ? navigateToInvList : undefined}
          sx={{
            width: 'fit-content',
            minWidth: 360,
            maxWidth: 440,
            p: 3.5,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            cursor: selectedTile ? 'pointer' : 'default',
            '&:hover': selectedTile ? { borderColor: 'primary.main', boxShadow: 2 } : {},
          }}
        >
          {selectedTile && US_STATE_SVG_PATHS[selectedTile['hc-a2']] && (
            <Box sx={{ mb: 1.5, lineHeight: 0 }}>
              <svg
                viewBox="0 0 400 300"
                style={{ width: '100%', height: 'auto', maxHeight: 120, display: 'block' }}
                aria-label={selectedTile.name}
              >
                <path
                  d={US_STATE_SVG_PATHS[selectedTile['hc-a2']]}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={3}
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          )}
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.2, mb: 1.5 }}>
            {selectedTile ? `${selectedTile.name} (${selectedTile['hc-a2']})` : 'Select a state'}
          </Typography>

          <Typography variant="h3" sx={{ fontWeight: 700, fontSize: '3.25rem', lineHeight: 1.05, mb: 2.5 }}>
            {selectedTile ? `${selectedTile.value}%` : '--%'}
          </Typography>

          {selectedTile?.value === 0 && selectedTile.firstExpectedInvoiceOn && (
            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem', lineHeight: 1.4, mb: 2.5 }}>
              First expected invoice on {selectedTile.firstExpectedInvoiceOn}
            </Typography>
          )}

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
            {selectedTile &&
              Object.entries(selectedTile.programInvoices || {}).map(([programKey, invoiceStats]) => (
                <Paper
                  key={programKey}
                  elevation={0}
                  sx={{
                    p: 1.75,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1.5,
                    backgroundColor: 'background.default',
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.125rem', lineHeight: 1.35 }}>
                    {programKey}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.125rem', lineHeight: 1.35 }}>
                    {invoiceStats.completed}/{invoiceStats.total} invoices
                  </Typography>
                </Paper>
              ))}
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: 'block', fontSize: '1rem', lineHeight: 1.35, mt: 2.25 }}
          >
            *Expected invoices are based on prior quarter
          </Typography>
        </Paper>

        {selectedTile?.hasDueAlert && (
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              p: 2.25,
              border: '2px solid',
              borderColor: 'error.main',
              borderRadius: 2,
              backgroundColor: 'error.lighter',
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, color: 'error.main', fontSize: '1.05rem', lineHeight: 1.35 }}
            >
              Due Amount in under 7 days
            </Typography>
            <Typography variant="h6" sx={{ mt: 0.75, fontWeight: 700, color: 'error.dark', lineHeight: 1.25 }}>
              {formatCurrency(selectedTile.dueAmount)}
            </Typography>
          </Paper>
        )}

        {selectedTile?.hasDisputeAlert && (
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              p: 2.25,
              border: '2px solid',
              borderColor: 'warning.main',
              borderRadius: 2,
              backgroundColor: 'error.lighter',
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, color: 'warning.dark', fontSize: '1.05rem', lineHeight: 1.35 }}
            >
              Large disputed amount
            </Typography>
            <Typography variant="h6" sx={{ mt: 0.75, fontWeight: 700, color: 'warning.dark', lineHeight: 1.25 }}>
              {formatCurrency(selectedTile.disputeAmount)}
            </Typography>
          </Paper>
        )}
      </Box>
    </Box>
  );
};
